import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { makeStyles, IconButton, SvgIcon } from '@material-ui/core';
import { logout } from 'src/actions/accountActions';
import { LogOut as LogOutIcon } from 'react-feather';
import axios from 'src/utils/axiosHelper';
import { BootstrapTooltip } from 'src/components/Tooltip';
import helperAxios from 'src/utils/helperAxios';

const useStyles = makeStyles(theme => ({ root: {} }));

function Logout() {
  const classes = useStyles();
  const history = useHistory();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleLogout = async () => {
    try {
      await dispatch(logout());
      history.push('/');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  return (
    <BootstrapTooltip title="Logout">
      <IconButton color="inherit" onClick={handleLogout}>
        <SvgIcon>
          <LogOutIcon />
        </SvgIcon>
      </IconButton>
    </BootstrapTooltip>
  );
}

export default Logout;
